import TermsAndPoliciesHeader from 'pages/terms-and-policies/header/TermsAndPoliciesHeader'
import TermsAndPoliciesItemContent from 'pages/terms-and-policies/item/TermsAndPoliciesItemContent'
import React, { useEffect } from 'react'
import {  useParams } from 'react-router-dom'
import { useLegal } from 'common/hooks/useLegal'

const TermsAndPoliciesItem = () => {
  const { id } = useParams();
  const { legalDoc, getLegal } = useLegal()
  useEffect(() => {
    if (id) {
      getLegal(id);
    }
  }, [id, getLegal]);

  return (
    <>
      <TermsAndPoliciesHeader item={legalDoc} />
      <TermsAndPoliciesItemContent title={legalDoc?.title || ''} content={legalDoc?.content || ''} />
    </>
  )
}

export default TermsAndPoliciesItem
